<template lang="pug">
	.element-effects-add(v-show="showed" :style="position" v-pseudo-modal-name="'element-effects-add'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="addEffect($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'EditorElementInfoEffectsAdd',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show EditorElementInfoEffectsAdd": function(el, element) {

					this.element = element;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

					this.update();

				},
				// Клик в любом месте кроме контента помеченного element-effects-add - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'element-effects-add') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: {},
		data() {
			return {
				position: {
					right: 0,
					bottom: 0
				}
			};
		},
		methods: {
			collectData() {

				let animationsItem = {title: 'Animations library', width: 200, opened: false, childs: [
					{title: 'Show', width: 200, opened: false, childs: _.map(_.orderBy(_.filter(Metadata.Animations, o => o.type === 'show'), 'priority'), animation => {
						return {..._.pick(animation, ['title', 'description']), width: 200, disabled: !animation.active, data: {animationCodename: animation.codename}}}
					)},
					{title: 'Hide', width: 200, opened: false, childs: _.map(_.orderBy(_.filter(Metadata.Animations, o => o.type === 'hide'), 'priority'), animation => {
						return {..._.pick(animation, ['title', 'description']), width: 200, disabled: !animation.active, data: {animationCodename: animation.codename}}}
					)},
					{title: 'Attention', width: 200, opened: false, childs: _.map(_.orderBy(_.filter(Metadata.Animations, o => o.type === 'attention'), 'priority'), animation => {
						return {..._.pick(animation, ['title', 'description']), width: 200, disabled: !animation.active, data: {animationCodename: animation.codename}}}
					)}
				]};

				let emittersItem = {title: 'Emitters library', width: 200, opened: false, childs: _.map(_.orderBy(Metadata.Emitters, 'priority'), emitter => {
					return {..._.pick(emitter, ['title', 'description']), width: 200, disabled: !emitter.active, data: {emitterCodename: emitter.codename}}}
				)};

				let emptyItem = {title: 'Empty animation', description: 'Create animation from scratch', width: 200, data: {emptyAnimation: true}};

				//let soundItem = {title: 'Sounds', width: 200, opened: false, disabled: true, childs: []};

				let eventItemsTree = [
					emptyItem,
					animationsItem,
					emittersItem,
					//soundItem
				];

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(eventItemsTree);

			},
			addEffect(item, data) {

				if (data.animationCodename) this.selectAnimation(data.animationCodename);
				else if (data.emitterCodename) this.selectEmitter(data.emitterCodename);
				else if (data.emptyAnimation) this.createEmptyAnimation();

			},
			selectAnimation(animationCodename) {

				Server.sendToSocket({
					AddAnimation: {
						elementId: this.element.id,
						animationCodename: animationCodename
					}
				});

				this.close();

			},
			selectEmitter(emitterCodename) {

				Server.sendToSocket({
					AddEmitter: {
						elementId: this.element.id,
						emitterCodename: emitterCodename
					}
				});

				this.close();

			},
			createEmptyAnimation() {

				Server.sendToSocket({
					CreateEmptyAnimation: {
						elementId: this.element.id
					}
				});

				this.close();

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.element-effects-add
		position: absolute
		margin-top: 1px
		user-select: none

</style>
